<template>
  <BaseButton
    v-if="!!bdxStatusList.length"
    :loading="isSaving"
    size="sm"
    @click="handleSave"
    >Save</BaseButton
  >
</template>

<script>
import { defineComponent, inject, ref } from '@vue/composition-api'

import { LincolnGlobalUMRService } from '@services'
import { useTryCatch, useToast, useCurrentUser } from '@composables'

import { BaseButton } from '@components/base'

import { BDXStatusPendingManagerInjectionKey } from './BDXStatusPendingManager.constants'

export default defineComponent({
  name: 'BDXStatusPendingManagerSaveButton',
  components: {
    BaseButton
  },
  emits: ['success'],
  setup(_, { emit }) {
    const { userEmail } = useCurrentUser()

    const { showToast } = useToast()

    const { bdxStatusList } = inject(BDXStatusPendingManagerInjectionKey)

    const isSaving = ref(false)

    const handleSave = async () => {
      isSaving.value = true

      await useTryCatch(async () => {
        const { data } = await LincolnGlobalUMRService.updateStatus(
          userEmail.value,
          bdxStatusList.value,
          true
        )
        const { message } = data || {}

        showToast(message)

        emit('success')
      })

      isSaving.value = false
    }

    return {
      bdxStatusList,

      isSaving,
      handleSave
    }
  }
})
</script>
